import React from "react";
import PropTypes from "prop-types";
import { TvSpan } from "@trustvid/design-system";

/**
 * Yellow Canva-style crown badge for Premium-locked UI shown to Free accounts.
 * Prototype source of truth: public/prototypes/saas-self-serve/_shared/mock-data.js
 * (`window.TV_SAAS.crownSvg`). Color comes from the `tv-premium-crown` CSS class
 * (`--tv-premium-crown-color` token, #f5c518) — never a hardcoded hex in JSX.
 */
const TvPremiumCrown = ({ className = "", title = "Premium", size = 14 }) => (
  <TvSpan
    className={["tv-premium-crown", className].filter(Boolean).join(" ")}
    role="img"
    aria-label={title}
    title={title}
  >
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M5 16.5 3.2 8.8c-.15-.65.55-1.15 1.1-.75L8 10.5 11.15 5.2a1 1 0 0 1 1.7 0L16 10.5l3.7-2.45c.55-.4 1.25.1 1.1.75L19 16.5H5zm-.5 1.5h15v2.2a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V18z"
      />
    </svg>
  </TvSpan>
);

TvPremiumCrown.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.number,
};

/**
 * Shared gate so the sidebar (TVD-1301) and Plans page (TVD-1303) decide
 * "show a crown" the same way instead of duplicating Free/Premium checks.
 * @param {boolean} shouldShow
 * @param {object} [props] forwarded to TvPremiumCrown
 * @returns {JSX.Element|null}
 */
export const renderPremiumCrownIf = (shouldShow, props) =>
  shouldShow ? <TvPremiumCrown {...props} /> : null;

export default TvPremiumCrown;
